import { render } from "./FrontDesk.vue?vue&type=template&id=90a1c88e&scoped=true"
import script from "./FrontDesk.vue?vue&type=script&lang=js"
export * from "./FrontDesk.vue?vue&type=script&lang=js"

import "./FrontDesk.vue?vue&type=style&index=0&id=90a1c88e&scoped=true&lang=css"
import "./FrontDesk.vue?vue&type=style&index=1&id=90a1c88e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90a1c88e"]])

export default __exports__